import i18n from '../translations';
import { Platform } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { getMe, updateSingleUser, updatePassword } from "../services/userService";

export const getUser = () => dispatch => {
    dispatch(request({ loggedIn: true }));
    getMe().then((user) => {
        // handle success
        if (user && user.dateOfBirth) {
            const dateObj = new Date(user.dateOfBirth);
            user.dateOfBirth = dateObj.getFullYear() + '-' + ('0' + (dateObj.getMonth() + 1)).slice(-2) + '-' + ("0" + dateObj.getDate()).slice(-2);
        }
        user.loggedIn = true;
        if (Platform.OS === 'web') {
            localStorage.setItem('langugae', user.language || 'en');
        } else {
            AsyncStorage.setItem('USER_LANGUAGE', user.language, () => {
            });
        }
        i18n.changeLanguage(user.language);
        dispatch(success(user));
    })
        .catch((error) => {
        // handle error
            dispatch(failure(error.toString()));
        });

    function request(user) {
        return { type: 'GET_USER_REQUEST', user };
    }

    function success(user) {
        return { type: 'GET_USER_SUCCESS', user };
    }

    function failure(error) {
        return { type: 'GET_USER_FAILURE', error };
    }

};

/**
 * Update user Action.
 * @param id
 * @param data
 * @returns {function(*): *}
 */
export const updateUser = (id, data) => (dispatch, getState) => {
    const { user } = getState();
    const previousLang = user.language;
    updateSingleUser(id, data)
        .then((user) => {
            user.loggedIn = true;
            const lang = user.language || 'en';
            if (Platform.OS === 'web') {
                localStorage.setItem('langugae', lang);
            } else {
                AsyncStorage.setItem('USER_LANGUAGE', lang, () => {
                });
            }
            i18n.changeLanguage(user.language);
            if (previousLang !== lang) {
                dispatch({
                    type: 'USER_LANGUAGE_UPDATED'
                });
            }
            dispatch({
                type: 'USER_UPDATE',
                payload: user
            });
        })
        .catch((error) => {
            // handle error
            dispatch({
                type: 'USER_UPDATE',
                payload: []
            });
        });
};

export const changePassword = (id, oldPassword, password) => dispatch => {
    const userData = {
        id: id,
        oldPassword: oldPassword,
        password: password
    };
    updatePassword(userData)
        .then((data) => {
            dispatch({
                type: 'CHANGE_PASSWORD',
                payload: data
            });
        })
        .catch((error) => {
            // handle error
            dispatch({
                type: 'CHANGE_PASSWORD',
                payload: []
            });
        });

};
